export const FEATURED_PRODUCT_TESTID = 'featured-product';
